import React, { Component } from 'react';
import _ from 'underscore';
import { render } from 'react-dom';
import {applyRouterMiddleware, Router, Route, browserHistory} from 'react-router';
import { Provider } from 'react-redux';
import pubSUb from 'PubSub';
import { useScroll } from 'react-router-scroll';
import { bindActionCreators } from 'redux';
import MainCommunityContainerView from './views/reactViews/MainCommunityContainerView';
import AgendaContainer from './views/reactViews/AgendaView/AgendaContainer';
import MainUserProfileContainerView from './views/reactViews/MainUserProfileContainerView';
import MainInboxContainerView from './views/reactViews/MainInboxContainerView';
import MainSettingsContainerView from './views/reactViews/MainSettingsContainerView';
import MainChangeEmailContainerView from './views/reactViews/MainChangeEmailContainerView';
import MainApproveChangeEmailContainerView from './views/reactViews/MainApproveChangeEmailContainerView';
import FeatureToggleUtils from 'FeatureToggleUtils';
import LoaderView from './views/reactViews/LoaderView';
import storeFactory from './store/store';
import reactBackboneInit from './ReactBackboneInit';
import { validateLinkedInToken } from './actions/CommunityActions';
import WebSocket from 'models/WebSocket';
import BootstrapData from 'models/BootstrapData';
import 'iframe-resizer-content-window';
import $ from 'jquery';
import SpeakerContainer from './views/reactViews/AgendaView/SpeakerView/SpeakerContainer';
import SessionPageContainer from './views/reactViews/AgendaView/SessionPageContainer';
import withEmailLogin from './hocs/withEmailLogin';
import cls from 'classnames';
import {loadCustomCode} from './CustomCode';
import withMe from './withMe';
import { withInstanaPageTracking } from '@bizzabo/instana';
import serviceConfig from 'config';
import { startSnowplowTrackingAction } from './actions/snowplowActions';
import { initializeSnowplowTrackerIfEnabled } from './utils/SnowplowUtils';
import useApplyCustomizations from './utils/useApplyCustomizations';

const withTracking = (trackingOptions) =>
    Comp => withInstanaPageTracking({ ...trackingOptions, instanaKey: serviceConfig?.instanaKey})(Comp);

const webSocket = new WebSocket();
const initialState = window.__INITIAL_STATE__;
const store = storeFactory(initialState);
const event = BootstrapData('bootstrap-data-event');
const { template = '' } = BootstrapData('bootstrap-data-siteConf') || {};
import {isBizzaboInternalWebsiteWhiteLabeled} from '@bizzabo/whitelabel-utils';
import { saveUrlParamsToSessionStorage } from './utils/saveUrlParamsToSessionStorage';
import { useHistoryTracker } from './utils/ReactHooks';

const actions = bindActionCreators({
    validateLinkedInToken,
    startSnowplowTrackingAction,
}, store.dispatch);

const createRoutes = routes => {
    const isWL = isBizzaboInternalWebsiteWhiteLabeled(event);
    const wlPath = event.whitelabelPath;
    return _(routes)
        .chain()
        .pairs()
        .map(pair => {
            if (!isWL) {
                return pair;
            }
            const [name, url] = pair;
            const uniqueNamePlaceholder = /^:unique_name/;
            const wlPathWithoutLeadingSlash = wlPath.replace(/^\//, '');
            const realUrl = url.replace(uniqueNamePlaceholder, wlPathWithoutLeadingSlash)
                .replace(/^\//, '');
            return [name, realUrl];
        })
        .object()
        .value();
};

const routes = createRoutes({
    community: ':unique_name/community',
    person: ':unique_name/person/:id',
    inboxId: ':unique_name/inbox/:id',
    inbox: ':unique_name/inbox',
    settings: ':unique_name/settings',
    changeEmail: ':unique_name/settings/changeEmail',
    changeEmailApproval: ':unique_name/settings/changeEmailApproval',
    agenda: ':unique_name/agenda',
    sessionPage: ':unique_name/agenda/session/:id',
    speaker: ':unique_name/agenda/speakers/:id',
    notFound: '*'
});

FeatureToggleUtils.mergeFeatureToggleWithConfig();

class MainContainer extends Component {
    componentDidMount() {
        saveUrlParamsToSessionStorage({
            windowLocationSearch: this.props.location.search,
            eventId: event?.id,
        });
        reactBackboneInit(store.dispatch, webSocket);
        const _loadCustomCode = (timeout = 1000) => {
            setTimeout(() => loadCustomCode({serverRendered: true}), timeout);
        };
        if (document.readyState !== 'loading') {
            _loadCustomCode(2000);
        } else {
            document.addEventListener('DOMContentLoaded', _loadCustomCode);
        }
        initializeSnowplowTrackerIfEnabled();
        actions.startSnowplowTrackingAction();
    }


    render() {
        const mainReactClass = cls('main-react-view', {[template]: template });

        return (
            <div className={mainReactClass}>
                {this.props.children}
            </div>
        );
    }
}

function scrollParentIFrameToTop() {
    window.parentIFrame && window.parentIFrame.sendMessage('scrollToTop', '*');
}

function onRouteChange() {
    scrollParentIFrameToTop();
    pubSUb.publish('analytics:routeChanged');
}

const onCommunityEnter = async(nextState, replace, callback) => {
    const sendMessage = (message) => window.parentIFrame && window.parentIFrame.sendMessage(`${message}`, '*');

    const { location: { pathname } = {}, params: { id } = {} } = nextState;
    if (pathname.includes('inbox')){
        if (id){
            sendMessage('communityIframeShouldResize');
        } else {
            window.iFrameResizer = {
                readyCallback: () => sendMessage('communityIframeShouldResize')
            };
        }
    } else if (pathname.includes('community')) {
        window.iFrameResizer = {
            readyCallback: () => sendMessage('communityIframeShouldResizeToDefault')
        };
    }
    try {
        await actions.validateLinkedInToken();
        callback();
    } catch (e) {
        callback();
    }
};

const AppRoutes = () => {
    useApplyCustomizations(event.id);

    return (
        <div data-iframe-height>
            <Provider store={store}>
                <Router history={browserHistory} render={applyRouterMiddleware(useScroll())}>
                    <Route path="/" component={MainContainer} onChange={onRouteChange}>
                        <Route path={routes.community} component={withTracking({ page: 'Community' })(withEmailLogin(MainCommunityContainerView))} onEnter={onCommunityEnter} />
                        <Route path={routes.person} component={withTracking({ page: 'Community Profile' })(MainUserProfileContainerView)} onEnter={onCommunityEnter} />
                        <Route path={routes.inboxId} component={withTracking({ page: 'Community Inbox' })(MainInboxContainerView)} onEnter={onCommunityEnter} />
                        <Route path={routes.inbox} component={withTracking({ page: 'Community Inbox' })(MainInboxContainerView)} onEnter={onCommunityEnter} />
                        <Route path={routes.settings} component={withTracking({ page: 'User Settings' })(MainSettingsContainerView)} />
                        <Route path={routes.changeEmail} component={withTracking({ page: 'Change Email' })(MainChangeEmailContainerView)} />
                        <Route path={routes.changeEmailApproval} component={withTracking({ page: 'Approve Change Email' })(MainApproveChangeEmailContainerView)} />
                        <Route path={routes.speaker} component={withTracking({ page: 'Speaker' })(SpeakerContainer)} />
                        <Route path={routes.agenda} component={withTracking({ page: 'Agenda' })(withMe(AgendaContainer))} />
                        <Route path={routes.sessionPage} component={withTracking({ page: 'Session' })(withMe(SessionPageContainer))} />
                    </Route>
                    <Route path={routes.notFound} component={() => (<LoaderView />)} onEnter={() => window.location.reload()} />
                </Router>
            </Provider>
        </div>
    );
};

render(<AppRoutes />, document.getElementsByClassName('react-main')[0]);

